'use client';
import { useEffect, useState } from 'react';

/**
 * Debounce a loading state
 *
 * When given a loading state, this hook will delay the value to avoid flashing
 * loading states for very short durations.
 */
export function useSpinner(loading: boolean, delay = 500): boolean {
  const [state, setState] = useState(loading);
  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => setState(true), delay);
      return () => clearTimeout(timer);
    } else {
      setState(false);
    }
  }, [delay, loading]);
  return loading ? state : false;
}
